export const scrollToHash = (hash) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(hash, { offset: -120 });
  } else {
    document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
  }
};
